<template>
  <div>
    <empty-state
      v-if="loading || !data || data.length === 0"
      :loading="loading"
      :title="loading ? $t('loading') : $t('no_data_available')"
      :subtitle="!loading ? $t('no_users_found') : ''"
      icon="mdi-account-group"
    />
    <div v-else class="pa-1">
      <!-- Mobile View -->
      <mobile-data-cards
        v-if="device.isMobile"
        :headers="mobileHeaders"
        :items="customSearch(data, mobileHeaders, searchQuery, ['name', 'lastname', 'email', 'phone', 'card_code'])"
        :loading="loading"
        item-key="id"
        :fields-per-row="null"
        :show-row-number="false"
        :bold-fields="['order_count', 'order_payed']"
      >
        <template v-slot:item.nameAndEmail="{ item }">
          <div>
            <div style="font-size: 1.1em; margin-bottom: 4px">
              {{ toLatin(item.name) }} {{ toLatin(item.lastname) }}
            </div>
            <div style="font-size: 0.9em; color: #666">
              {{ item.email }}
            </div>
          </div>
        </template>
      </mobile-data-cards>

      <!-- Desktop View -->
      <v-data-table
        v-else
        :headers="headers"
        :items="customSearch(data, headers, searchQuery, ['name', 'lastname', 'email', 'phone', 'card_code'])"
        class="striped-table ordera-box-shadow"
        :loading="loading"
        dense
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.num="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.nameAndEmail="{ item }">
          <div>
            <div style="font-size: 1.1em; margin-bottom: 4px">
              {{ toLatin(item.name) }} {{ toLatin(item.lastname) }}
            </div>
            <div style="font-size: 0.9em; color: #666">
              {{ item.email }}
            </div>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";
import MobileDataCards from "@/components/global/MobileDataCards.vue";

export default {
  name: "KorisniciTable",
  components: {
    EmptyState,
    MobileDataCards,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("id"), value: "id", sortable: false },
        { text: this.$t("name_surname"), value: "nameAndEmail", sortable: false },
        {
          text: this.$t("ordered"),
          value: "order_count",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("taken"),
          value: "order_payed",
          sortable: false,
          align: "center",
        },
      ];
    },
    mobileHeaders() {
      return [
        { text: this.$t("name_surname"), value: "nameAndEmail", sortable: false, cols: 12 },
        { text: this.$t("id"), value: "id", sortable: false, cols: 4 },
        {
          text: this.$t("ordered"),
          value: "order_count",
          sortable: false,
          align: "center",
          cols: 4,
        },
        {
          text: this.$t("taken"),
          value: "order_payed",
          sortable: false,
          align: "center",
          cols: 4,
        },
      ];
    },
  },
};
</script>
